<template>
    <div
        class="map-checkbox"
        :class="{
            'map-disabled': disabled,
        }">
        <label class="map-checkbox-inner" :for="unique_id">
            <input
                type="checkbox"
                :disabled="disabled"
                :id="unique_id"
                v-bind="$attrs"
                v-model="model"
                />
            <span class="map-checkbox-checkmark"></span>
            <span class="map-checkbox-label"><slot></slot></span>
        </label>
    </div>
</template>

<script>
    export default
    {
        name: 'checkbox',
        props:
        {
            checked: Boolean,
            disabled: Boolean,
        },
        model:
        {
            prop: 'checked',
        },
        data()
        {
            return {
                unique_id: '',
                touched: false,
            };
        },
        computed:
        {
            model:
            {
                get()
                {
                    return this.checked;
                },
                set(value)
                {
                    if (!this.touched)
                    {
                        this.touched = true;
                    }

                    this.$emit('update:checked', value);
                }
            },
        },
        created()
        {
            this.unique_id = Math
                .random()
                .toString(16)
                .slice(2);
        },
    }
</script>
